/* istanbul ignore file */
import Box from '@mui/material/Box';

/* istanbul ignore next */
export default Box;
export * from '@mui/material/Box';
export type { BoxProps as Props } from '@mui/material/Box';
